import { EditPlanningTemplatePage } from "@features/rh/horaires-de-travail/components/EditPlanningTemplatePage";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, useParams } from "@tanstack/react-router";

function EditPlanningTemplatePageWrapper() {
  const { id } = useParams({ from: "/_app/rh/horaires-de-travail/$id/edit" });
  return <EditPlanningTemplatePage planningTemplateId={Number(id)} />;
}

export const Route = createFileRoute("/_app/rh/horaires-de-travail/$id/edit")({
  loader: requirePermission(PERMISSIONS.RH.PLANNING.EDIT),
  staticData: {
    title: "Modifier l'horaire",
    permission: PERMISSIONS.RH.PLANNING.EDIT,
    module: "rh",
    showInTab: false,
    showInNav: false,
    showInBreadcrumb: true,
  },
  component: EditPlanningTemplatePageWrapper,
});
